import { API_CONFIG, buildEndpoint } from '../config/api.config';
import apiClient from './apiClient';

const unwrapList = (payload, key) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.[key])) return payload[key];
  if (Array.isArray(payload?.data?.[key])) return payload.data[key];
  return [];
};

const unwrapObject = (payload, key) => {
  if (payload?.[key]) return payload[key];
  if (payload?.data?.[key]) return payload.data[key];
  if (payload?.data && typeof payload.data === 'object') return payload.data;
  return payload || null;
};

export const getPromptSlots = async (slotKey) => {
  const response = await apiClient.get(API_CONFIG.dcr.getPromptSlots.endpoint, {
    params: slotKey ? { slot_key: slotKey } : undefined,
  });

  return unwrapList(response.data, 'PromptSlots');
};

export const getAgentPromptRules = async (status) => {
  const response = await apiClient.get(API_CONFIG.dcr.getAgentPromptRules.endpoint, {
    params: status ? { status } : undefined,
  });

  return unwrapList(response.data, 'agentPromptRules');
};

export const getAgentPromptRuleById = async (ruleId) => {
  const response = await apiClient.get(
    buildEndpoint(API_CONFIG.dcr.getAgentPromptRuleById.endpoint, { ruleId })
  );

  return unwrapObject(response.data, 'agentPromptRule');
};

export const updateAgentPromptRule = async (ruleId, payload) => {
  const response = await apiClient.put(
    buildEndpoint(API_CONFIG.dcr.updateAgentPromptRule.endpoint, { ruleId }),
    payload
  );

  return unwrapObject(response.data, 'agentPromptRule');
};
export const getFeedbackBySlotKey = async (slotKey) => {
  const response = await apiClient.get(
    buildEndpoint(API_CONFIG.dcr.getFeedbackBySlotKey.endpoint, { slotKey })
  );

  return unwrapList(response.data, 'llmFeedbacks');
};
